import { StateHandler } from "../../StateHandler";
import { GenericActions } from "../../../actions/GenericActions";
import { ArrayUtils, E_Modification, EO, get, StringUtils } from "@green24/npm-javascript-utils";

const defaultInitialState = {
	data: null,
	fetching: true,
	fetched: false,
	failed: false,
	error: null,
	lastUpdate: undefined,
};

export class ListStateHandler extends StateHandler {
	static get model() {
		return {
			defaultInitialState,
		}
	}

	constructor({actionPrefix, itemActionPrefix, initialState = defaultInitialState, listItemsPath = "content", itemUpdateDirtiesList = false}) {
		super({initialState, defaultInitialState});

		this.actionPrefix = actionPrefix;
		this.itemActionPrefix = itemActionPrefix;
		this.listItemsPath = listItemsPath;
		this.itemUpdateDirtiesList = itemUpdateDirtiesList;
	}

	handleAction(action) {
		const {state, actionPrefix, itemActionPrefix} = this;

		switch (action.type) {
			case `${actionPrefix}_${GenericActions.enum.actionType.FETCH_PENDING}`:
				return {
					...state,
					fetching: true,
					failed: false,
					error: null,
				};
			case `${actionPrefix}_${GenericActions.enum.actionType.BACKGROUND_FETCH_PENDING}`:
				return {
					...state,
					fetching: true,
				};
			case `${actionPrefix}_${GenericActions.enum.actionType.FETCH_FULFILLED}`:
				return {
					...state,
					data: action.payload,
					fetched: true,
					fetching: false,
					lastUpdate: new Date(),
				};
			case `${actionPrefix}_${GenericActions.enum.actionType.FETCH_REJECTED}`:
				return {
					...state,
					fetching: false,
					failed: true,
					error: action.payload,
				};
			case `${itemActionPrefix}_${GenericActions.enum.actionType.EDIT_PENDING}`:
				return {
					...state,
					fetching: true,
				};
			case `${itemActionPrefix}_${GenericActions.enum.actionType.EDIT_FULFILLED}`:
				return {
					...state,
					...this._handleGenericItemEdit(state, action.payload),
				};
			case `${itemActionPrefix}_${GenericActions.enum.actionType.ITEM_DELETE}`:
				return {
					...state,
					...this._handleGenericItemDelete(state, action.payload),
				};
			case `${itemActionPrefix}_${GenericActions.enum.actionType.CACHE_CLEAR}`:
				return {
					...state,
					lastUpdate: undefined,
				};
			default:
				return state;
		}
	}

	_handleGenericItemEdit(state, item) {
		const rootPath = StringUtils.appendIfValid(this.listItemsPath, '.');
		const itemPath = `${rootPath}#${item.id}`;

		if(get(state.data, itemPath)) {
			if(this.itemUpdateDirtiesList) {
				return {
					lastUpdate: undefined,
				}
			}

			let newEditData = EO(state.data).clone(true);
			newEditData.modifyV2(item, itemPath, E_Modification.ITEM_SET);

			return {
				fetching: false,
				data: newEditData,
				lastUpdate: new Date(),
			}
		}
	}

	_handleGenericItemDelete(state, item) {
		const collectionPath = this.listItemsPath;

		if(this.itemUpdateDirtiesList) {
			const itemsCollection = get(state.data, collectionPath);
			if(itemsCollection) {
				if(ArrayUtils.findByID(itemsCollection, item.id)) {
					//Collection is valid and the item is present, invalidate it.
					return {
						lastUpdate: undefined,
					}
				}
				else {
					//Do nothing.
					//Collection is valid and the item is not present in the collection.
				}
			}
			else {
				//Collection is invalid for some reason. Just in case invalidate it all.
				return {
					lastUpdate: undefined,
				}
			}
		}

		let newData = EO(state.data).clone(true);
		newData.modifyV2(item.id, collectionPath, E_Modification.ARRAY_REMOVE_BY_ID);

		return {
			data: newData,
		}
	}
}
